import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import ActionCellRender from "../../components/actionCellRender";
import {
  IconTrash,
  IconPencil,
  IconCopy,
  IconSettings,
  IconAlertTriangle,
  IconCircleCheck,
} from "@tabler/icons";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import { useCellRender } from "../../hooks/useCellRender";
import OrderPageStats from "../../components/orderPageStats";
import FileList, { K_FILE_LIST_DISPLAY_MODE } from "../../components/fileList";
import { IMAGE_MIME_TYPE } from "@mantine/dropzone";
import ActivityLog from "../../components/activityLog.js";
import RemoteSelect2 from "../../components/remoteSelect2";
import FollowupActionTable from "../../components/followupActionTable.js";
import ClientRiskStats from "../../components/clientRiskStats";
import ClientAMLList from "../../components/clientAMLList";
import ClientRPQList from "../../components/clientRPQList";
import OrderClientPanel from "../../components/orderClientPanel";
import OrderSummary from "../../components/orderSummary";
import OrderPolicy from "../../components/orderPolicy";
import OrderPointPanel from "../../components/pointBalances";
import OrderPolicyNumberInput from "../../components/orderPolicyNumberInput";
import OrderPaymentDetail from "../../components/orderPaymentDetail";
import OrderProductDetail from "../../components/orderProductDetail";
import OrderConsultantList from "../../components/orderConsultantList";
import OrderRiderList from "../../components/orderRiderList";
import OrderServiceList from "../../components/orderServiceList";
import OrderRelatedPersonDetail from "../../components/orderRelatedPersonDetail";
import OrderInsuredDetail from "../../components/orderInsuredDetail";
import OrderActionList from "../../components/orderActionList";
import { DATA_ORDER_TYPE, DATA_COUNTRY, getMpfAccountTypeOptions, DATA_ORDER_APPLICATION_METHOD, DATA_ORDER_POLICY_DOCUMENT_TYPE } from "../../data/options";
import Chips from "../../components/chips";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { useLocation } from "react-router-dom";

import ConsultantList from "../../components/consultantList";
import OrderPaymentDetailForm from "../../components/orderPaymentDetailForm";
import OrderProductVariation from "../../components/orderProductVariation";
import ProductSelection from "../../components/productSelection";
import OrderQuotationList from "../../components/orderQuotationList";
import OrderInvoiceList from "../../components/orderInvoiceList";
import OrderCommissionPaymentList from "../../components/orderCommissionPaymentList";
import OrderCommissionPaymentSummary from "../../components/orderCommissionPaymentSummary";
import OrderCommission from "../../components/orderCommission";
import OrderProfolio from "../../components/orderProfolio";
import FormConfirmation from "../../components/formConfirmation";
import { useAccessRight } from "../../hooks/useAccessRight";
import OrderCommissionSetting from "../../components/orderCommissionSetting";
import {
  Select,
  Checkbox,
  TextInput,
  Switch,
  Text,
  List,
  ThemeIcon,
  Group,
  Badge,
} from "@mantine/core";
import _ from "lodash";
import { DatePicker } from "@mantine/dates";
import { useAuthUser } from "react-auth-kit";
import OrderBeneficiaryList from "../../components/orderBeneficiaryList";
import OrderInsuredList from "../../components/orderInsuredList";
import ConsultantSelect from "../../components/consultantSelect";
import OrderAddressSelect from "../../components/orderAddressSelect";
import moment from "moment";
import RemarkList from "../../components/remarkList";
import { useServerApi } from "../../hooks/userServerApi";
import {
  applyTeamUserFilters,
  CONSULTANT_TEAM_SEARCH_ENABLED,
  getTeamUserIds,
  HANDLER_FILTER_USER_PRE_QUERY,
  isConsultantPortalRole,
} from "../../helpers/consultantTeamFilter";
import { shouldRedirectToConsultantPortal } from "../../helpers/consultantPortalRedirect";
import DummyWidget from "../../components/dummyWidget";
import OrderTimeline from "../../components/orderTimeline";
import OrderDNTimeLine from "../../components/orderDNTimeLine";
import OrderPendingCase from "../../components/orderPendingCase";
import OrderAlert from "../../components/orderAlert";
import { useTranslation } from "react-i18next";
import {
  buildOrderFormValidate,
  ORDER_CONFIRM_FIELD_LABELS,
} from "../../helpers/orderFormValidate";
import { isMpfProduct, isInvestmentTransactionsProduct, isIlasProduct } from "../../helpers/orderProductUtils";
import OrderInvestmentClientRpq from "../../components/orderInvestmentClientRpq";
import OrderInvestmentAccount from "../../components/orderInvestmentAccount";
import OrderInvestmentTransactionList from "../../components/orderInvestmentTransactionList";
import {
  CommissionRegenerationPromptBridge,
} from "../../components/commissionRegenerationPrompt";
import { pickCommissionAffectingSnapshot } from "../../helpers/commissionOrderChangeUtils";
import { applyCommissionRegenerationPrompt } from "../../helpers/prepareOrderSaveWithCommissionPrompt";

const apiEntity = "order";
const initialValues = {
  type: "NEW",
  name: "",
  payment: {},
  termination: {},
  signedPlace: "Hong Kong",
  consultants: [],
  signedDate: "", //moment().format("YYYY-MM-DD"),
  premiumFinancing: false,
  policyReplacement: false,
  taxable: true,
  consultantLicenceError: null,
  checkConsultantLicenceOnConfirm: false,
  consultantLicenceChecking: false,
  arForm: { ifastAccountNo: "" },
};

export const notAllowAddFormSchema = {
  name: "notAllowAddOrderSchema",
  title: "Notification",
  description: "Sorry. You are not allowed to create new order anymore.",

  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "1000px", //xs, sm, xl  ....100%
  },

  apiEntity,
  initialValues,
  validate: {},
  showSaveBar: false,
  layout: {
    containers: [
      {
        key: "section-notice",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "",
          description: "You are not allowed to create order.",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
    ],

    fields: [
      {
        name: "notification",
        component: DummyWidget,
        parent: "section-notice",
        props: {
          dummyRender: (formValues) => (
            <>
              <List mt={"xl"} spacing="xs" size="sm" center>
                <List.Item>
                  Sorry. You are not allowed to create new order now.
                </List.Item>
                <List.Item>
                  It is probably the CPD doesn't meet the requirement.
                </List.Item>
                <List.Item>
                  Please contact management to resolve the issue.
                </List.Item>
              </List>
            </>
          ),
        },
      },
    ],
  },
};
export const getAddFormSchema = (t) => ({
  name: "AddOrderSchema",
  title: "New Order",
  description: "Please follow the step to create a New Order",

  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "1000px", //xs, sm, xl  ....100%
  },

  apiEntity,
  initialValues,

  validate: buildOrderFormValidate(t),
  showSaveBar: false,

  layout: {
    containers: [
      {
        key: "t1",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,

        props: {
          variant: "default", //default | pills | outline
          defaultValue: "Order Type",
          orientation: "vertical",
          style: { minHeight: "400px" },
        },
        steps: [
          { key: "t1-1", label: "Order Type", icon: IconSettings },
          { key: "t1-10", label: "Policy", icon: IconSettings },

          { key: "t1-2", label: "Client", icon: IconSettings },
          { key: "t1-9", label: "Insured", icon: IconSettings },
          { key: "t1-4", label: "Consultants", icon: IconSettings },
          { key: "t1-handlers", label: "Handlers", icon: IconSettings },

          { key: "t1-3", label: "Product", icon: IconSettings },
          { key: "t1-5", label: "Sign Detail", icon: IconSettings },
          {
            key: "t1-8",
            label: "Product Variation",
            icon: IconSettings,
          },
          {
            key: "t1-6",
            label: "Payment Details",
            icon: IconSettings,
          },
          { key: "t1-7", label: "Confirmation", icon: IconSettings },
        ],
      },
      {
        key: "section-type",
        parent: "t1-1",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Order Types",
          description: "Pleaes select the order type",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      {
        key: "section-policy",
        parent: "t1-10",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Policy",
          description: "",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      {
        key: "section-client",
        parent: "t1-2",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Client",
          description: "Pleaes select the client",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      // {
      // 	key: "section-insured",
      // 	parent: "t1-9",
      // 	type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
      // 	props: {
      // 		title: "Insured",
      // 		description: "Pleaes fillin the insured details",
      // 		withBorder: false,
      // 		mt: 0,
      // 		ml: 20,
      // 	},
      // },
      {
        key: "section-consultant",
        parent: "t1-4",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Consultants",
          description: "Please select the consultants",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      {
        key: "section-handler",
        parent: "t1-handlers",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Handlers",
          description: "Operation staff who handle policy data input",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },

      {
        key: "section-product",
        parent: "t1-3",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Product",
          description: "Please select the product",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },

      {
        key: "section-variation",
        parent: "t1-8",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Product Variation",
          description: "Please select the product variation",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },

      {
        key: "section-sign",
        parent: "t1-5",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Sign Details",
          description: "Please fillin the sign details",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      {
        key: "section-payment",
        parent: "t1-6",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Payment Details",
          description: "Please fillin the payment details",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      {
        key: "section-insured",
        parent: "t1-9",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Insured",
          description: "Please fillin the insured details",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },
      {
        key: "section-confirm",
        parent: "t1-7",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Confirmation",
          description: "Please confirm the creation of order",
          withBorder: false,
          mt: 0,
          ml: 20,
        },
      },

      {
        key: "payment-g",
        parent: "section-payment-details",
        type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
        cols: [
          {
            key: "payment-g1",
            props: {
              span: 6,
            },
          },
          {
            key: "payment-g2",
            props: {
              span: 6,
            },
          },
        ],
      },
    ],

    fields: [
      {
        name: "type",
        component: Chips,
        parent: "section-type",
        props: {
          required: true,
          // label: "Order Types",
          labelOrder: 5,
          // description: "Please Select the type of order.",
          items: DATA_ORDER_TYPE,
          defaultValue: "NEW",
          multiple: false,
        },
      },
      {
        name: "policyNumber",
        component: OrderPolicyNumberInput,
        parent: "section-policy",
        props: {
          // required: true,
        },
      },
      {
        name: "applicationMethod",
        component: Select,
        parent: "section-policy",
        props: {
          label: "Application",
          data: DATA_ORDER_APPLICATION_METHOD,
          clearable: true,
        },
      },
      {
        name: "policyDocumentType",
        component: Select,
        parent: "section-policy",
        props: {
          label: "Policy",
          data: DATA_ORDER_POLICY_DOCUMENT_TYPE,
          clearable: true,
        },
      },
      {
        name: "dateBackOption",
        component: Switch,
        parent: "section-policy",
        props: {
          type: "checkbox",
          label: "Date Back Option",
          size: "xs",
        },
      },
      {
        name: "premiumFinancing",
        component: Switch,
        parent: "section-policy",
        props: {
          type: "checkbox",
          label: "Premium Financing",
          size: "xs",
        },
      },
      {
        name: "policyReplacement",
        component: Switch,
        parent: "section-policy",
        props: {
          type: "checkbox",
          label: "Policy Replacement",
          size: "xs",
        },
      },

      {
        name: "clientPanel",
        component: OrderClientPanel,
        parent: "section-client",
        props: {
          mode: "create",
        },
      },

      {
        name: "product",
        component: ProductSelection,
        parent: "section-product",
        props: {
          filterByOrderType: true,
        },
      },
      {
        name: "mpfAccountType",
        component: Select,
        parent: "section-product",
        visibleOnly: (values) => isMpfProduct(values),
        props: {
          label: "MPF Account Type",
          required: true,
          placeholder: "",
          data: getMpfAccountTypeOptions(t),
          searchable: true,
          clearable: true,
        },
      },

      {
        name: "consultants",
        component: RemoteSelect2,
        parent: "section-consultant",
        props: {
          apiEntity: "user",
          required: true,
          // label: "Consultant",
          placeholder: "Please select consultant(s)",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `[${data.staffId ?? " -- "}] ${data.name}${
              data.aliasName ? `, ${data.aliasName}` : ""
            }${data.cname ? ` ${data.cname}` : ""}`,
          multiple: true,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          pageSize: 2000,
          searchFields: [
            "aliasName",
            "name",
            "staffId",
            "cname",
            "email",
            "phone",
          ],
          sort: {
            by: "staffId",
            order: "asc",
          },
        },
      },
      {
        name: "consultantList",
        component: ConsultantList,
        parent: "section-consultant",
        props: {
          field: "consultants",
        },
      },

      {
        name: "handlerBy",
        component: RemoteSelect2,
        parent: "section-handler",
        props: {
          apiEntity: "user",
          label: "Handler 1",
          placeholder: "Please select handler 1",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: false,
          preQuery: { status: "ACTIVE" },
          searchFields: ["name", "staffId", "cname", "email", "aliasName"],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "handlerBy2",
        component: RemoteSelect2,
        parent: "section-handler",
        props: {
          apiEntity: "user",
          label: "Handler 2",
          placeholder: "Please select handler 2",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: false,
          preQuery: { status: "ACTIVE" },
          searchFields: ["name", "staffId", "cname", "email", "aliasName"],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },

      {
        name: "signedDate",
        component: DatePicker,
        parent: "section-sign",
        type: "datePicker",
        props: {
          required: true,
          label: "Sign Date",
          zIndex: 1000,
          // placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "signedPlace",
        component: Select,
        parent: "section-sign",
        props: {
          required: true,
          label: "Sign Place",
          placeholder: "",
          data: DATA_COUNTRY,
          defaultValue: "Hong Kong",
          searchable: true,
        },
      },
      {
        name: "signedBy",
        component: RemoteSelect2,
        parent: "section-sign",
        props: {
          apiEntity: "user",
          required: true,
          label: "Sign By",
          placeholder: "Please select consultant who sign the order",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `,${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: false,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          searchFields: ["name", "staffId", "cname", "email", "aliasName"],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "signedBy2",
        component: RemoteSelect2,
        parent: "section-sign",
        props: {
          apiEntity: "user",
          required: false,
          label: "Sign By (2nd)",
          placeholder: "Please select consultant who sign the order",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: false,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          searchFields: ["name", "staffId", "cname", "email", "aliasName"],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },

      {
        name: "consultantListSign",
        component: ConsultantList,
        parent: "section-sign",
        props: {
          field: "signedBy",
        },
      },
      {
        name: "forceUncertainPayment",
        component: Switch,
        parent: "section-payment",
        props: {
          type: "checkbox",
          label: "This order has no confirmed payment details (e.g. MPF)",
          mb: "xl",
          size: "xs",
        },
      },
      {
        name: "payment",
        component: OrderPaymentDetailForm,
        parent: "section-payment",
        props: {},
      },

      {
        name: "productVariations",
        component: OrderProductVariation,
        parent: "section-variation",
        props: {},
      },

      {
        name: "confirm",
        component: FormConfirmation,
        parent: "section-confirm",
        props: {
          validateOnMount: true,
          fieldLabels: ORDER_CONFIRM_FIELD_LABELS,
        },
      },
      {
        name: "insured",
        component: OrderInsuredList,
        parent: "section-insured",
        props: {},
      },
    ],
  },
});

const insertWizardStepAfter = (steps, afterLabel, step) => {
  const index = steps.findIndex((item) => item.label === afterLabel);
  if (index < 0) return [...steps, step];
  return [...steps.slice(0, index + 1), step, ...steps.slice(index + 1)];
};

export const getEditOrderFormSchema = (t) => {
  const schema = getAddFormSchema(t);
  const wizard = schema.layout.containers.find(
    (container) => container.key === "t1"
  );

  wizard.steps = insertWizardStepAfter(wizard.steps, "Insured", {
    key: "t1-beneficiary",
    label: "Beneficiary",
    icon: IconSettings,
  });
  wizard.steps = insertWizardStepAfter(wizard.steps, "Payment Details", {
    key: "t1-files",
    label: "Files",
    icon: IconSettings,
  });

  schema.title = "Order Details";
  schema.layout.containers.push(
    {
      key: "section-beneficiary",
      parent: "t1-beneficiary",
      type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
      props: {
        title: "Beneficiary",
        description: "Please fillin the beneficiary details",
        withBorder: false,
        mt: 0,
        ml: 20,
      },
    },
    {
      key: "section-files",
      parent: "t1-files",
      type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
      props: {
        title: "Files",
        description: "Please upload order files",
        withBorder: false,
        mt: 0,
        ml: 20,
      },
    }
  );
  schema.layout.fields.push(
    {
      name: "beneficiary",
      component: OrderBeneficiaryList,
      parent: "section-beneficiary",
      props: {},
    },
    {
      name: "files",
      component: FileList,
      parent: "section-files",
      props: {},
    }
  );

  return schema;
};

export const addFormSchema = getAddFormSchema((key) => key);

export default function Order({ role = "MANAGEMENT" }) {
  const [cellRender] = useCellRender();
  const auth = useAuthUser();
  const authUser = auth();
  // Non-consultant roles get initial preQuery so PageList and stats render on load
  const [preQuery, setPreQuery] = useState(() => {
    if (role === "CONSULTANT" || role === "CHANNEL") return undefined;
    if (role === "OPERATION") return { isGI: { $in: [null, false] } };
    if (role === "GI-OPERATION") return { isGI: true };
    return {};
  });
  const tabNav = useTabNavigate();
  const [api] = useServerApi();
  const userRoleName = auth().userRole?.name?.toUpperCase() ?? "";
  const { pathname: currentURL } = useLocation();
  const [disableCreateOrder, setDisableCreateOrder] = useState(false);
  const [teamUserIds, setTeamUserIds] = useState(null);
  const [getAccessRight, accessRight] = useAccessRight();
  const { t } = useTranslation();
  const commissionBaselineRef = useRef(null);
  const lastBaselineVersionRef = useRef(null);

  const onOrderFormChange = useCallback((values) => {
    if (!values?._id) return;
    const version = `${values._id}:${values.updatedAt ?? ""}`;
    if (version !== lastBaselineVersionRef.current) {
      lastBaselineVersionRef.current = version;
      commissionBaselineRef.current = pickCommissionAffectingSnapshot(values);
    }
  }, []);

  const onOrderSubmit = useCallback(
    async ({ values, formMode }) => {
      if (formMode === "add") {
        return api.add({ apiEntity, values });
      }

      if (formMode !== "edit" || !values?._id) {
        return { success: false, error: "Invalid save request" };
      }

      let payload = { ...values };
      const promptResult = await applyCommissionRegenerationPrompt({
        values: payload,
        baseline: commissionBaselineRef.current,
      });
      if (promptResult.cancelled) {
        return { success: false, cancelled: true };
      }
      payload = promptResult.payload;

      const result = await api.updateById({
        apiEntity,
        id: values._id,
        values: payload,
      });

      if (result?.success && result?.data) {
        commissionBaselineRef.current = pickCommissionAffectingSnapshot(
          result.data
        );
        lastBaselineVersionRef.current = `${result.data._id}:${
          result.data.updatedAt ?? ""
        }`;
      }

      return result;
    },
    [api]
  );

  const editFormSchema = {
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
    },
    title: "Order",
    titleField: "code",
    apiEntity,
    initialValues,

    layout: {
      containers: [
        {
          key: "main-g",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
          props: {
            gutter: "xl",
            columns: 24,
          },
          cols: [
            {
              key: "main-g1",
              props: {
                span: 7,
              },
            },
            {
              key: "main-g2",
              props: {
                span: 17,
              },
            },
          ],
        },
        {
          key: "section-applicant",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Client",
            // titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-consultant",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.BOX,
          props: {
            mt: 0,
            mb: 0,
          },
        },

        {
          key: "section-action-list",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Action List",
            // titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 0,
            mb: 20,
          },
        },

        {
          key: "main-tab",
          parent: "main-g2",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Overview",
          },
          tab: [
            {
              key: "tab-overview",
              label: "Overview",
              //icon: IconSettings,
            },
            {
              key: "tab-service",
              label: "Service",
              //icon: IconSettings,
            },
            {
              key: "tab-related-person",
              label: "Related Person",
            },
            {
              key: "tab-risk",
              label: "Risk Control",
              // icon: IconSettings,
            },
            {
              key: "tab-transactions",
              label: "Transactions",
              showTab: (values) => isInvestmentTransactionsProduct(values),
            },
            {
              key: "tab-profolio",
              label: "Portfolio",
              showTab: (values) => isIlasProduct(values),
            },
            {
              key: "tab-files",
              label: "Files",
              //icon: IconSettings
            },
            // {
            //   key: "tab-documents",
            //   label: "Document",
            //   // icon: IconSettings,
            // },
            {
              key: "tab-commission",
              label: "Commission",
              showTab: () => {
                return role !== "CONSULTANT";
              },
              // icon: IconSettings,
            },
            {
              key: "tab-logs",
              label: "Logs",
              // icon: IconSettings
            },
            {
              key: "tab-handlers",
              label: "Handlers",
              showTab: () => false,
            },
          ],
        },

        {
          key: "section-alert",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.EMPTY,
          props: {
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-summary",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Summary",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 0,
            mb: 20,
          },
        },
        {
          key: "section-service",
          parent: "tab-service",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Services",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 0,
            mb: 20,
          },
        },
        {
          key: "section-timeline",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Timeline",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-dn-timeline",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          visibleOnly: (values) => values?.dnTimeLine,
          props: {
            title: "DN Timeline",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-policy",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Policy Info",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-points",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Promotion Points",
            titleOrder: 5,
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-product",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Product",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-payment",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Payment",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-riders",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Riders",
            titleOrder: 5,

            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-pending",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Pending Cases",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-remarks",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Remarks",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-address",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Address",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },

        // {
        //   key: "section-followup",
        //   parent: "tab-overview",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Followup Tickets",
        //     titleOrder: 5,
        //     // description: "Please assign the corresponding consultant",
        //     withBorder: false,
        //     minHeight: 0,

        //     mt: 20,
        //     mb: 20,
        //   },
        // },

        {
          key: "section-insured",
          parent: "tab-related-person",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Insured",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-beneficiary",
          parent: "tab-related-person",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Beneficiary & Trustee",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-risk-stats",
          parent: "tab-risk",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Risk Summary",
            minHeight: "0px",
          },
        },
        {
          key: "section-risk-pep",
          parent: "tab-risk",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "PEP",
          },
        },

        {
          key: "section-risk-aml",
          parent: "tab-risk",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "AML",
            minHeight: "0px",
          },
        },
        {
          key: "section-risk-rpq",
          parent: "tab-risk",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "RPQ",
            minHeight: "0px",
          },
        },
        {
          key: "section-investment-client-rpq",
          parent: "tab-transactions",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Client & RPQ",
            description: "Read-only — pulled from the linked client record.",
            minHeight: 0,
            mb: "lg",
          },
        },
        {
          key: "section-investment-account",
          parent: "tab-transactions",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Investment Account",
            description: "iFAST account number saved on this order.",
            minHeight: 0,
            mb: "lg",
          },
        },
        {
          key: "section-investment-transactions",
          parent: "tab-transactions",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Transaction",
            description:
              "Each row is a separate AR Form (Parts A–C). Open a row to edit or print.",
            minHeight: 0,
            mb: "lg",
          },
        },

        // {
        //   key: "section-quotation",
        //   parent: "tab-documents",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Quotation",
        //     minHeight: "0px",
        //   },
        // },
        // {
        //   key: "section-invoice",
        //   parent: "tab-documents",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Invoice",
        //     minHeight: "0px",
        //   },
        // },

        {
          key: "section-log",
          parent: "tab-logs",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Log",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-handler",
          parent: "tab-handlers",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Handlers",
            description: "Operation staff who handle policy data input",
            withBorder: false,
            mt: 20,
            mb: 20,
          },
        },

        // {
        //     key: "section-profolio",
        //     parent: "tab-profolio",
        //     type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //     props: {
        //         // title: "Fund Profolio",
        //         titleOrder: 5,
        //         // description: "Please assign the corresponding consultant",
        //         withBorder: false,
        //         minHeight: "0px",
        //         // mt: 20,
        //         mb: 20,
        //     },
        // },

        {
          key: "section-files",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          visibleOnly: () => role !== "CONSULTANT",
          props: {
            title: "Files",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-specimen-signature",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          visibleOnly: () => role !== "CONSULTANT",
          props: {
            title: "Specimen Signature",
            titleOrder: 5,
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-consultant-files",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title:
              role === "CONSULTANT"
                ? "Files"
                : "Files (Shared with Consultant)",
            titleOrder: 5,
          },
          // Visible for management (to manage shared files) and for consultant (to view shared files)
        },

        // {
        //   key: "section-commission-payment-summary",
        //   parent: "tab-commission",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Summary",
        //     titleOrder: 5,
        //     // description: "Please assign the corresponding consultant",
        //     withBorder: false,
        //     minHeight: "0px",
        //     mt: 20,
        //     mb: 20,
        //   },
        // },

        // {
        //   key: "section-commission-setting",
        //   parent: "tab-commission",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Commission Setting",
        //     titleOrder: 5,
        //     withBorder: false,
        //     minHeight: "0px",
        //     mt: 20,
        //     mb: 20,
        //   },
        // },

        // {
        //   key: "section-commission-payment",
        //   parent: "tab-commission",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   props: {
        //     title: "Commission Payments",
        //     titleOrder: 5,
        //     // description: "Please assign the corresponding consultant",
        //     withBorder: false,
        //     minHeight: "0px",
        //     mt: 20,
        //     mb: 20,
        //   },
        // },

        {
          key: "section-commission",
          parent: "tab-commission",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Commission",
            titleOrder: 5,
            withBorder: false,
            minHeight: 0,
            mt: 0,
            mb: 20,
          },
        },

        {
          key: "section-tax",
          parent: "tab-commission",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Tax",
            titleOrder: 5,
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },
      ],

      fields: [
        {
          name: "files",
          component: FileList,
          parent: "section-files",
          props: {
            disabled: accessRight !== 15,
          },
        },

        {
          name: "specimenSignatureFiles",
          component: FileList,
          parent: "section-specimen-signature",
          props: {
            disabled: accessRight !== 15,
            defaultDisplayMode: K_FILE_LIST_DISPLAY_MODE.GRID,
            uploadLabel: "Upload Chop / Signature",
            accept: IMAGE_MIME_TYPE,
          },
        },

        {
          name: "consultantFiles",
          component: FileList,
          parent: "section-consultant-files",
          props: {
            disabled: accessRight !== 15,
          },
        },

        {
          name: "log",
          component: ActivityLog,
          parent: "section-log",
          props: {},
        },

        // {
        //   name: "followup",
        //   component: FollowupActionTable,
        //   parent: "section-followup",
        //   props: {},
        // },

        {
          name: "pendingCases",
          component: OrderPendingCase,
          parent: "section-pending",
          props: {},
        },
        {
          name: "clientPanel",
          component: OrderClientPanel,
          parent: "section-applicant",
          props: {
            mode: "edit",
          },
        },

        {
          name: "orderRemarks",
          component: RemarkList,
          parent: "section-remarks",
          props: {
            scrollHeight: 100,
            disabled: accessRight !== 15,
            placeholder: "Enter to add remark",
          },
        },

        {
          name: "riders",
          component: OrderRiderList,
          parent: "section-riders",
          props: {},
        },

        {
          name: "services",
          component: OrderServiceList,
          parent: "section-service",
          props: {},
        },
        {
          name: "riskStats",
          component: ClientRiskStats,
          parent: "section-risk-stats",
          props: {
            clientIDField: "client._id",
          },
        },

        {
          name: "riskAML",
          component: ClientAMLList,
          parent: "section-risk-aml",
          props: {
            clientIDField: "client._id",
          },
        },

        {
          name: "riskRPQ",
          component: ClientRPQList,
          parent: "section-risk-rpq",
          props: {
            clientIDField: "client._id",
          },
        },
        {
          name: "client?.pep?.isPep",
          component: Checkbox,
          parent: "section-risk-pep",
          props: {
            label: "is Political Exposure Person? (PEP)",
            type: "checkbox",
            variant: "filled",
            disabled: true,
          },
        },
        {
          name: "client?.pep?.remark",
          component: TextInput,
          parent: "section-risk-pep",
          props: {
            label: "Remark",
            variant: "filled",
            disabled: true,
          },
        },

        // {
        //   name: "quotation",
        //   component: OrderQuotationList,
        //   parent: "section-quotation",
        //   props: {
        //     clientIDField: "client._id",
        //   },
        // },

        // {
        //   name: "riskRPQ",
        //   component: OrderInvoiceList,
        //   parent: "section-invoice",
        //   props: {
        //     clientIDField: "client._id",
        //   },
        // },
        {
          name: "alert",
          component: OrderAlert,
          parent: "section-alert",
          props: {
            mt: 0,
            mb: 0,
            p: 0,
          },
        },
        {
          component: OrderSummary,
          parent: "section-summary",
          props: {},
        },
        {
          component: OrderTimeline,
          parent: "section-timeline",
          props: {},
        },
        {
          component: OrderDNTimeLine,
          parent: "section-dn-timeline",
          props: {},
        },
        {
          name: "profolio",
          component: OrderProfolio,
          parent: "tab-profolio",
          props: {},
        },

        {
          component: OrderPolicy,
          parent: "section-policy",
          props: {},
        },
        {
          component: OrderPointPanel,
          parent: "section-points",
          props: {},
        },

        {
          component: OrderProductDetail,
          parent: "section-product",
          props: {},
        },
        {
          component: OrderPaymentDetail,
          parent: "section-payment",
          props: {},
        },

        {
          name: "address",
          component: OrderAddressSelect,
          parent: "section-address",
          props: {
            disabled: accessRight !== 15,
          },
        },

        {
          name: "consultants",
          component: OrderConsultantList,
          parent: "section-consultant",
          props: {},
        },

        {
          name: "handlerBy",
          component: RemoteSelect2,
          parent: "section-handler",
          props: {
            apiEntity: "user",
            label: "Handler 1",
            placeholder: "Please select handler 1",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
                data.staffId ?? " -- "
              })`,
            multiple: false,
            preQuery: { status: "ACTIVE" },
            searchFields: ["name", "staffId", "cname", "email", "aliasName"],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },
        {
          name: "handlerBy2",
          component: RemoteSelect2,
          parent: "section-handler",
          props: {
            apiEntity: "user",
            label: "Handler 2",
            placeholder: "Please select handler 2",
            valueField: "_id",
            labelField: "name",
            labelRender: (data) =>
              `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
                data.staffId ?? " -- "
              })`,
            multiple: false,
            preQuery: { status: "ACTIVE" },
            searchFields: ["name", "staffId", "cname", "email", "aliasName"],
            sort: {
              by: "name",
              order: "asc",
            },
          },
        },

        {
          name: "insured",
          component: OrderInsuredList,
          parent: "section-insured",
          props: {},
        },
        {
          name: "beneficiary",
          component: OrderBeneficiaryList,
          parent: "section-beneficiary",
          props: {},
        },
        {
          name: "investmentClientRpq",
          component: OrderInvestmentClientRpq,
          parent: "section-investment-client-rpq",
          props: {},
        },
        {
          name: "investmentAccount",
          component: OrderInvestmentAccount,
          parent: "section-investment-account",
          props: {},
        },
        {
          name: "investmentTransactions",
          component: OrderInvestmentTransactionList,
          parent: "section-investment-transactions",
          props: {},
        },

        {
          name: "orderAction",
          component: OrderActionList,
          parent: "section-action-list",
          props: {
            role: userRoleName,
          },
        },

        // {
        //   name: "commissionPaymentSummary",
        //   component: OrderCommissionPaymentSummary,
        //   parent: "section-commission-payment-summary",
        //   props: {},
        // },

        {
          name: "commission",
          component: OrderCommission,
          parent: "section-commission",
          props: {},
        },
        {
          name: "taxable",
          component: Switch,
          parent: "section-tax",
          fieldSpacing: "xs",
          props: {
            type: "checkbox",
            label: "Taxable",
            size: "xs",
          },
        },

        // {
        //   name: "commissionSetting",
        //   component: OrderCommissionSetting,
        //   parent: "section-commission-setting",
        //   props: {},
        // },

        // {
        //   name: "commissionPayments",
        //   component: OrderCommissionPaymentList,
        //   parent: "section-commission-payment",
        //   props: {},
        // },
      ],
    },
  };
  // Consultant users should use the consultant portal; staff roles (including
  // Administrator and custom back-office roles) may open management/operation routes as-is.
  useEffect(() => {
    if (!shouldRedirectToConsultantPortal(userRoleName)) return;

    if (currentURL.includes("operation")) {
      tabNav.replace({
        pathname: currentURL.replace("operation", "consultant"),
        label: "Order",
      });
      return;
    }

    if (currentURL.includes("management")) {
      tabNav.replace({
        pathname: currentURL.replace("management", "consultant"),
        label: "Order",
      });
    }
  }, [userRoleName, currentURL, tabNav]);

  useEffect(() => {
    if (!authUser?.id) return;
    let cancelled = false;
    (async () => {
      try {
        const user = await api.getById({ apiEntity: "user", id: authUser.id });
        if (!cancelled) setDisableCreateOrder(user?.disableCreateOrder ?? false);
      } catch (error) {
        console.log(error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authUser?.id]);

  const actionList = editFormSchema.layout.fields.find(
    (f) => f.name === "orderAction",
  );

  const reviseSchemaForConsultant = async (activeRole = role) => {
    // console.log("Revise Schema for consultant", role, auth());
    //Consultant
    try {
      const teamIds = await getTeamUserIds(auth, api);
      if (!isConsultantPortalRole(activeRole)) return;

      setTeamUserIds(teamIds);

      if (CONSULTANT_TEAM_SEARCH_ENABLED) {
        setPreQuery({ consultants: { $in: teamIds } });
      } else {
        setPreQuery({ consultants: auth().id });
      }

      initialValues.consultants = [auth().id];
      initialValues.signedBy = auth().id;

      //Clients
      const clientField = addFormSchema.layout.fields.find(
        (f) => f.name === "clientPanel",
      );
      if (clientField) {
        clientField.props.preQuery = { consultants: auth().id };
      }

      //Set Action List
      actionList.props.role = role;

      const tabLayout = editFormSchema.layout.containers.find(
        (c) => c.key === "main-tab",
      );
      tabLayout.tab = tabLayout.tab.filter((t) => t.key != "tab-commission");

      // console.log("Tab Layout", tabLayout);
    } catch (error) {
      console.log("Revise Schema for consultant error", error);
      if (!isConsultantPortalRole(activeRole)) return;
      // Fallback so page and stats render
      setTeamUserIds([auth().id]);
      setPreQuery({ consultants: auth().id });
    }
  };

  useEffect(() => {
    switch (role) {
      case "CONSULTANT":
        reviseSchemaForConsultant(role);
        break;

      case "CHANNEL":
        reviseSchemaForConsultant(role);
        break;

      case "OPERATION":
        setTeamUserIds(null);
        setPreQuery({ isGI: { $in: [null, false] } });
        initialValues.handlerBy = auth().id;
        //Set Action List
        actionList.props.role = role;

        break;

      case "ACCOUNT":
        setTeamUserIds(null);
        setPreQuery({});
        initialValues.handlerBy = auth().id;
        //Set Action List
        actionList.props.role = "OPERATION";
        break;

      case "ADMINISTRATOR":
      case "MANAGEMENT":
        setTeamUserIds(null);
        setPreQuery({});
        initialValues.handlerBy = auth().id;
        //Set Action List
        actionList.props.role = "OPERATION";
        break;

      case "GI-OPERATION":
        setTeamUserIds(null);
        setPreQuery({ isGI: true });
        initialValues.handlerBy = auth().id;
        //Set Action List
        actionList.props.role = role;

        break;
    }
  }, [role]);

  const tableSchema = {
    showActionColumn: true,
    preQuery,
    copyToNewFields: [
      "type",
      "client",
      "jointClient",
      "jointClientSnapShot",
      "address",
      "consultants",
      "handlerBy",
      "handlerBy2",
      "signedBy",
      "signedBy2",
      "product",
      "productCategory",
      "productType",
      "provider",
      "productVariations",
      "productCustomOptions",
      "signedPlace",
      "signedDate",
      "payment",
      "insured",
      "applicant",
      "owner",
      "checkList",
      "isGI",
      "professionalInvestor",
      "mainlandChineseVisitor",
      "mpfAccountType",
      "dateBackOption",
      "premiumFinancing",
      "policyReplacement",
      "taxable",
      "insuredAge",
      "orderRemarks",
      "arForm",
    ],
    select: [
      "code product productType provider policyNumber policyCommenceDate client consultants status createdAt signedAt type pendingCases mcaPending mcaRequestId",
    ],
    columns: (() => {
      const cols = [
      {
        field: "code",
        headerName: "Order",
        sortable: true,
        cellRender: (col, order) => cellRender.Order.code(order),
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "status",
          label: "Order Status",
          width: 250,
          height: 300,
        },
      },

      {
        field: "pendingCases",
        headerName: "Pending",
        sortable: true,
        cellRender: (col, order) => {
          const pendingCases =
            order.pendingCases?.filter((c) => !c.completed) ?? [];
          const completedCases =
            order.pendingCases?.filter((c) => c.completed) ?? [];
          return _.isEmpty(pendingCases) ? (
            _.isEmpty(completedCases) ? (
              ""
            ) : (
              <Badge color="green" radius={0} size="xs">
                <Group spacing={1} noWrap>
                  <IconCircleCheck size={15} />
                  {`${completedCases?.length} DONE`}
                </Group>
              </Badge>
            )
          ) : (
            <Badge color="red" radius={0} size="xs">
              <Group spacing={1} noWrap>
                <IconAlertTriangle size={15} />
                {`${pendingCases?.length} PENDING`}
              </Group>
            </Badge>
          );
        },
      },

      {
        field: "product",
        headerName: "Product",
        sortable: true,
        cellRender: (col, data) => {
          if (data.product) return cellRender.ProductInfo(data.product);
          if (data.productType || data.provider)
            return <Text color="dimmed">{cellRender.ProductInfo2(data)}</Text>;
        },
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "productCategory",
          label: "Product Category",
          populate: {
            model: "ProductCategory",
            select: "name cname code shortName",
            labelField: "name",
            sort: { code: 1 },
          },

          width: 250,
          height: 300,
        },
      },
      {
        field: "_filterProductTypeClass",
        headerName: "Product Type (Class)",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "productType",
          label: "Product Type (Class)",
          width: 350,
          height: 300,
          populate: {
            model: "ProductType",
            select: "name cname code shortName",
            labelField: "name",
            sort: { code: 1 },
          },
        },
      },
      {
        field: "_filterConsultants",
        headerName: "Consultants",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "consultants",
          label: "Consultants",
          width: 300,
          height: 320,
          populate: {
            model: "User",
            select: "name cname staffId aliasName",
            labelField: "name",
            sort: { name: 1 },
          },
        },
      },
      {
        field: "_filterHandler",
        headerName: "Handler",
        filterOnly: true,
        filterable: true,
        filter: {
          field: "_filterHandler",
          label: "Handler",
          includeEmpty: true,
          width: 300,
          height: 320,
          orFields: ["handlerBy", "handlerBy2"],
          userPreQuery: HANDLER_FILTER_USER_PRE_QUERY,
          populate: {
            model: "User",
            select: "name cname staffId aliasName",
            labelField: "name",
            sort: { name: 1 },
          },
        },
      },
      {
        field: "policyNumber",
        headerName: "Policy No.",
        sortable: true,
        cellRender: (col, data) => (
          <>
            <Text size="xs">{data.policyNumber || "-"}</Text>
            <Text color="dimmed" size="xs" sx={{ whiteSpace: "nowrap" }}>
              {data.policyCommenceDate
                ? moment(data.policyCommenceDate).format("YYYY-MM-DD")
                : ""}
            </Text>
          </>
        ),
      },
      {
        field: "client",
        sortable: true,
        width: 350,
        cellRender: (col, data) => cellRender.ClientInfo(data.client, true),
      },
      {
        field: "consultants",
        headerName: "Consultants",
        sortable: true,
        cellRender: (col, data) => cellRender.Users(data.consultants, 3, true),
      },

      // {   field: 'followup', sortable: true,   },
      // {
      // 	field: "status",
      // 	sortable: true,
      // 	cellRender: (col, data) => cellRender.Status(data.status),
      // },

      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
        actionMenu:
          accessRight === 15
            ? [
                {
                  name: "copy",
                  label: "Duplicate",
                  icon: IconCopy,
                  props: {},
                },
                {
                  name: "delete",
                  label: "Delete data",
                  icon: IconTrash,
                  props: {
                    color: "red",
                    disabled: (data) => data.status !== "DFT",
                  },
                },
              ]
            : null,
      },
    ];
      if (isConsultantPortalRole(role) && teamUserIds) {
        applyTeamUserFilters(cols, teamUserIds, ["consultants"]);
      }
      return cols;
    })(),

    searchableFields: ["status", "searchText"],
  };
  const formSchema = useMemo(
    () => ({
      add: disableCreateOrder ? notAllowAddFormSchema : getAddFormSchema(t),
      edit: editFormSchema,
    }),
    [disableCreateOrder, t, accessRight, userRoleName, role]
  );

  return (
    <>
      {/* role: {role} */}
      {preQuery && (
        <CommissionRegenerationPromptBridge>
          <PageList
            key={currentURL}
            title={"Orders"}
            apiEntity={apiEntity}
            tableSchema={tableSchema}
            formSchema={formSchema}
            onSubmit={onOrderSubmit}
            onChange={onOrderFormChange}
            importVariants={[
              {
                key: "orderData",
                label: "Order Data",
                templateDownloads: [
                  {
                    url: `${process.env.REACT_APP_SERVER_URL}/order/downloadTemplate`,
                    text: "Download Template",
                  },
                ],
              },
              {
                key: "policyInsured",
                label: "Policy Insured",
                templateDownloads: [
                  {
                    url: `${process.env.REACT_APP_SERVER_URL}/order/downloadPolicyInsuredTemplate`,
                    text: "Download Template",
                  },
                ],
                onImport: (file, _context, api) =>
                  api.Order.importPolicyInsuredBatch(file),
              },
              {
                key: "policyBeneficiary",
                label: "Policy Beneficiary",
                templateDownloads: [
                  {
                    url: `${process.env.REACT_APP_SERVER_URL}/order/downloadPolicyBeneficiaryTemplate`,
                    text: "Download Template",
                  },
                ],
                onImport: (file, _context, api) =>
                  api.Order.importPolicyBeneficiaryBatch(file),
              },
            ]}
            initSort={{ by: "createdAt", order: "desc" }}
            searchByTextField={false}
            // preQuery={preQuery}
            // preQueryNotEmpty={true}
            stats={{
              component: OrderPageStats,
              props: {
                mb: 35,
                role,
                preQuery,
              },
            }}
          />
        </CommissionRegenerationPromptBridge>
      )}
    </>
  );
}
